import { Button } from '@mui/material';

import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../redux/actions';
import OtRequestTable from '../../components/Table/OtRequestTable';
import AddOt from './AddOt';
import { confirmAsync } from '../../utils/functions/globalDialog';

export default function OvertimeRequestList({ title, subtitle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const me = useSelector((state) => state.me);
  const otRequests = useSelector((state) => state.otRequestOrder);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  // เปิด modal อัตโนมัติถ้ามาจากลิงก์ "ขอ OT" ในหน้าอื่น (เช่น ListTimestamp.js หลัง checkout)
  // ที่ push state มาพร้อม openAdd:true — แทนที่การ navigate ไป /profile/ot/add เดิม
  const [addOpen, setAddOpen] = useState(!!location.state?.openAdd);

  const refetch = () => dispatch(actions.otRequestOrderAll({ me: me?.userData?.id }));

  useEffect(() => {
    refetch();
    if (location.state?.openAdd) {
      history.replace('/profile/ot');
    }

    return () => {};
  }, []);

  const handleDelete = async (id) => {
    const confirm = await confirmAsync('ยืนยันลบคำขอ OT ใช่หรือไม่ ?');
    if (confirm) {
      dispatch(actions.otRequestOrderDelete(id)).then(() => {
        refetch();
      });
    }
  };

  const renderTable = () => (
    <OtRequestTable
      otRequest={otRequests}
      page={page}
      setPage={setPage}
      size={size}
      setSize={setSize}
      handleDelete={handleDelete}
    />
  );
  const renderButton = () => (
    <div className="flex justify-end p-1 ">
      <Button
        variant="contained"
        onClick={() => setAddOpen(true)}
        color="primary"
      >
        Request Overtime
      </Button>
    </div>
  );
  return (
    <div>
      {renderButton()}
      {renderTable()}
      <AddOt open={addOpen} onClose={() => setAddOpen(false)} onCreated={refetch} />
    </div>
  );
}
